import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, MousePointerClick, Heart, ArrowRight } from 'lucide-react';
const steps = [{
  n: 1,
  Icon: FolderOpen,
  title: 'Abrís el material',
  desc: 'Todo organizado por nivel y temática. Primaria en un megapack, Secundaria en otro. Encontrás lo que necesitás en segundos.'
}, {
  n: 2,
  Icon: MousePointerClick,
  title: 'Elegís la actividad o el proyecto',
  desc: 'Cada recurso viene listo, con objetivos pedagógicos, variantes y material imprimible.'
}, {
  n: 3,
  Icon: Heart,
  title: 'Lo aplicás con tus alumnos',
  desc: 'Sin improvisar. Sin perder horas planificando. Listo para enseñar.'
}];
export function Solution() {
  return <section className="py-24 lg:py-32 bg-brand-800 text-paper-card relative overflow-hidden" data-id="element-238">
      {/* Subtle organic shapes for editorial feel */}
      <div className="absolute -top-40 -right-40 w-[600px] h-[600px] bg-brand-700/30 rounded-full blur-[120px] pointer-events-none" data-id="element-239"></div>
      <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] bg-brand-900/40 rounded-full blur-[120px] pointer-events-none" data-id="element-240"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-20 max-w-3xl mx-auto" data-id="element-242">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-500/20 text-terra-100 font-medium text-xs uppercase tracking-widest mb-6 border border-terra-500/30" data-id="element-243">
            LA SOLUCIÓN
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium mb-6 leading-tight tracking-tight text-white" data-id="element-244">
            Por eso creamos{' '}
            <span className="text-accent-400" data-id="element-245">
              Sistema Profesional Arte Lista 2026
            </span>
          </h2>
          <p className="text-lg text-brand-100 font-normal" data-id="element-246">
            Un sistema completo para resolver todo tu año de Arte — para los dos
            niveles.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 relative" data-id="element-247">
          {/* Connector line desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-px border-t border-dashed border-brand-600/50 z-0" data-id="element-248"></div>

          {steps.map((step, i) => {
          const Icon = step.Icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.15,
            duration: 0.8,
            ease: 'easeOut'
          }} className="relative bg-brand-700/50 backdrop-blur-sm rounded-[20px] p-8 lg:p-10 border border-brand-600/30 z-10" data-id="element-249">
                {/* Number badge */}
                <div className="w-12 h-12 rounded-full bg-accent-500 text-brand-900 font-serif font-medium text-xl flex items-center justify-center mb-8" data-id="element-250">
                  {step.n}
                </div>
                <div className="w-12 h-12 rounded-full bg-brand-800/50 text-accent-300 flex items-center justify-center mb-6 border border-brand-600/50" data-id="element-251">
                  <Icon className="w-5 h-5" strokeWidth={1.5} data-id="element-252" />
                </div>
                <h3 className="font-serif font-medium text-2xl mb-4 leading-tight text-white" data-id="element-253">
                  {step.title}
                </h3>
                <p className="text-brand-100/80 leading-relaxed font-normal" data-id="element-254">
                  {step.desc}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mt-16" data-id="element-255">
          <p className="text-brand-200 inline-flex items-center gap-3 text-lg font-normal" data-id="element-256">
            Así de simple. <ArrowRight className="w-5 h-5 text-accent-400" data-id="element-257" />
            <span className="font-medium text-white" data-id="element-258">
              Sin improvisar. Sin perder horas planificando.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}